/*
  SLB__GENERATED_POST_BRIDGE__DO_NOT_EDIT
  Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
  Built: 2026-09-19T16:53:52.860Z
  Content-SHA256: fd31c7b9ef3bf669f898e28dc6b86232fcb332e939f45b991d385643431f30b2
*/

/*
  SLB Secure POST + Opaque Poll Transport V1 (Phase 5.2)
  ------------------------------------------------------
  The real SLB RPC payload is submitted in an HTTP POST body. The browser then
  retrieves the completed response using short-lived JSONP polls that contain
  only a cryptographically random channel ID and a response-part number.

  No callsign, PIN, session token, rich-text body, or real RPC arguments are put
  in a request URL. The historical JSONP transport is not used as a fallback by
  this client.
*/
(function(w, d){
  'use strict';
  if(w.SLBPostBridge && typeof w.SLBPostBridge.call === 'function') return;

  var VERSION = 'POST_POLL_V1';
  var LEGACY_VERSION = 'LEGACY_COMPAT_V1';
  var seq = 0;
  var active = Object.create(null);
  var MAX_ACTIVE = 18;
  var COMPAT_KEY = 'slb_transport_compat_v2';
  var LEGACY_MAX_CHARS = 48000;
  var DIAG_KEY = 'slb_transport_diag_v1';
  var DIAG_MAX = 60;
  var diagEvents = [];

  function now(){ return Date.now(); }
  function wait_(ms){ return new Promise(function(resolve){ setTimeout(resolve, ms); }); }

  function loadDiag_(){
    try{
      var raw = w.sessionStorage && w.sessionStorage.getItem(DIAG_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if(Array.isArray(arr)) diagEvents = arr.slice(-DIAG_MAX);
    }catch(_e){ diagEvents = []; }
  }

  function diagPush_(action, requestId, stage, elapsedMs, code){
    try{
      var row = {
        at: now(),
        action: String(action || '').slice(0, 80),
        requestId: String(requestId || '').slice(0, 120),
        stage: String(stage || '').slice(0, 40),
        elapsedMs: Math.max(0, Number(elapsedMs || 0) || 0),
        code: String(code || '').slice(0, 40)
      };
      diagEvents.push(row);
      if(diagEvents.length > DIAG_MAX) diagEvents.splice(0, diagEvents.length - DIAG_MAX);
      try{ if(w.sessionStorage) w.sessionStorage.setItem(DIAG_KEY, JSON.stringify(diagEvents)); }catch(_eStore){}
      try{ w.__SLB_TRANSPORT_DIAGNOSTICS__ = diagnostics(); }catch(_eExpose){}
    }catch(_e){}
  }

  loadDiag_();

  // Safari 12/13 lacks Promise.allSettled. Several SLB background helpers use
  // it after login, so provide a tiny standards-compatible polyfill.
  try{
    if(w.Promise && typeof w.Promise.allSettled !== 'function'){
      w.Promise.allSettled = function(items){
        return w.Promise.all(Array.prototype.map.call(items || [], function(item){
          return w.Promise.resolve(item).then(function(value){
            return { status:'fulfilled', value:value };
          }, function(reason){
            return { status:'rejected', reason:reason };
          });
        }));
      };
    }
  }catch(_ePoly){}

  function safariMajor_(){
    try{
      var ua = String((w.navigator && w.navigator.userAgent) || '');
      if(!/Safari\//.test(ua) || /(Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android)/.test(ua)) return 0;
      var m = ua.match(/Version\/(\d+)/);
      return m ? (parseInt(m[1], 10) || 0) : 0;
    }catch(_e){ return 0; }
  }

  function compatStored_(){
    try{
      var ss = w.sessionStorage && w.sessionStorage.getItem(COMPAT_KEY);
      var ls = w.localStorage && w.localStorage.getItem(COMPAT_KEY);
      return ss === '1' || ls === '1';
    }catch(_e){ return false; }
  }

  function compatForcedByUrl_(){
    try{
      var q = String((w.location && w.location.search) || '');
      return /(?:[?&])slb_compat=1(?:&|$)/.test(q);
    }catch(_e){ return false; }
  }

  function oldSafariCompat_(){
    var major = safariMajor_();
    return !!(major && major <= 14);
  }

  function enableCompat_(reason){
    try{ if(w.sessionStorage) w.sessionStorage.setItem(COMPAT_KEY, '1'); }catch(_e1){}
    try{ w.__SLB_TRANSPORT_MODE__ = LEGACY_VERSION; }catch(_e2){}
    diagPush_('transport', '', 'compat_enabled', 0, String(reason || 'AUTO').slice(0,40));
  }

  function shouldUseCompat_(){
    return compatForcedByUrl_() || compatStored_() || oldSafariCompat_();
  }

  function randomHex_(bytes){
    bytes = Math.max(12, Number(bytes || 24) || 24);
    try{
      if(w.crypto && typeof w.crypto.getRandomValues === 'function'){
        var a = new Uint8Array(bytes);
        w.crypto.getRandomValues(a);
        var out = '';
        for(var i = 0; i < a.length; i++) out += ('0' + a[i].toString(16)).slice(-2);
        return out;
      }
    }catch(_e){}
    return String(now().toString(36)) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }

  var ACTIVITY_PREFIX = 'slb_transport_activity_v1:';
  var ACTIVITY_STALE_MS = 180000;
  var TAB_ID = 'tab_' + now().toString(36) + '_' + randomHex_(8);

  function activeRows_(){
    var rows = [];
    try{
      Object.keys(active).forEach(function(k){
        var x = active[k] || {};
        rows.push({ requestId:k, action:String(x.action || ''), startedAt:Number(x.startedAt || now()) });
      });
    }catch(_e){}
    return rows;
  }
  function publishActivity_(){
    try{
      var rows = activeRows_();
      var key = ACTIVITY_PREFIX + TAB_ID;
      if(!rows.length){ w.localStorage && w.localStorage.removeItem(key); return; }
      if(w.localStorage) w.localStorage.setItem(key, JSON.stringify({ tabId:TAB_ID, updatedAt:now(), active:rows }));
    }catch(_e){}
  }
  function activity_(){
    var local = activeRows_(), shared = [], all = [];
    try{
      if(w.localStorage){
        var remove = [];
        for(var i=0;i<w.localStorage.length;i++){
          var key = w.localStorage.key(i);
          if(!key || key.indexOf(ACTIVITY_PREFIX) !== 0) continue;
          try{
            var row = JSON.parse(w.localStorage.getItem(key) || 'null');
            if(!row || !row.updatedAt || (now() - Number(row.updatedAt)) > ACTIVITY_STALE_MS){ remove.push(key); continue; }
            var entries = Array.isArray(row.active) ? row.active : [];
            entries.forEach(function(x){
              var out = { tabId:String(row.tabId || ''), requestId:String(x.requestId || ''), action:String(x.action || ''), ageMs:Math.max(0, now()-Number(x.startedAt || now())) };
              all.push(out); if(out.tabId !== TAB_ID) shared.push(out);
            });
          }catch(_eRow){ remove.push(key); }
        }
        remove.forEach(function(k){ try{ w.localStorage.removeItem(k); }catch(_eRm){} });
      }
    }catch(_e){}
    return { tabId:TAB_ID, local:local, shared:shared, all:all };
  }
  try{ w.addEventListener('pagehide', function(){ try{ if(w.localStorage) w.localStorage.removeItem(ACTIVITY_PREFIX + TAB_ID); }catch(_e){} }); }catch(_eHide){}

  function trustedAppsScriptOrigin_(origin){
    var value=String(origin||'');
    // Apps Script HtmlService can surface its sandboxed postMessage with the
    // opaque origin "null" in Firefox/privacy-filtered browsers. Every caller
    // of this helper also validates a fresh 144-bit+ per-request token before it
    // accepts the packet, so allow that sandbox origin instead of incorrectly
    // discarding the valid direct POST response and falling back to JSONP poll.
    if(value==='null') return true;
    return /^https:\/\/(?:script\.google\.com|[a-z0-9.-]*googleusercontent\.com)$/i.test(value);
  }

  function sameOriginDirectReturn_(){
    try{
      var origin=String(w.location&&w.location.origin||'');
      if(!/^https:\/\/(?:www\.)?tinyatdragon\.com$/i.test(origin)) return '';
      return origin.replace(/\/$/,'')+'/robots.txt';
    }catch(_e){ return ''; }
  }

  function safeEndpoint_(endpoint){
    var raw = String(endpoint || '').trim();
    if(!raw) throw new Error('Backend URL is missing.');
    var u;
    try{ u = new URL(raw, w.location && w.location.href ? w.location.href : undefined); }
    catch(_e){ throw new Error('Backend URL is invalid.'); }
    if(u.protocol !== 'https:') throw new Error('Backend URL must use HTTPS.');
    return u.href;
  }

  function requestId_(payload){
    var rid = String(payload && payload.requestId || '').trim();
    if(rid) return rid.slice(0, 120);
    return 'p51_' + now().toString(36) + '_' + (++seq).toString(36) + '_' + randomHex_(8);
  }

  function clientBuild_(){
    try{ return String(w.__SLB_BUILD_TAG__ || '').slice(0, 160); }catch(_e){ return ''; }
  }

  function normalizeError_(msg, fallback){
    var err = msg && msg.error;
    var code = '';
    var text = '';
    try{
      if(err && typeof err === 'object'){
        code = String(err.code || err.errorCode || '');
        text = String(err.message || '');
        if(!text) text = JSON.stringify(err);
      }else{
        text = String(err || fallback || 'Backend error');
      }
    }catch(_e){ text = String(fallback || 'Backend error'); }
    var out = new Error(text || String(fallback || 'Backend error'));
    if(code) out.code = code;
    if(err) out.details = err;
    return out;
  }

  function addField_(form, name, value){
    var input = d.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = String(value == null ? '' : value);
    form.appendChild(input);
  }

  function submitByForm_(endpoint, outerText, channel){
    var host = d.body || d.documentElement;
    if(!host) throw new Error('Page is not ready for secure transport.');
    var frameName = 'slb_secure_submit_' + now().toString(36) + '_' + (++seq).toString(36) + '_' + randomHex_(5);
    var iframe = d.createElement('iframe');
    var form = d.createElement('form');
    var phase = 'boot';
    var completedResolve = null;
    var completed = new Promise(function(resolve){ completedResolve = resolve; });
    var bootFallback = 0;

    iframe.name = frameName;
    iframe.title = 'SLB secure request';
    iframe.setAttribute('data-slb-secure-transport-frame', 'submit');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.tabIndex = -1;
    iframe.referrerPolicy = 'no-referrer';
    iframe.style.cssText = 'position:fixed!important;left:-10000px!important;top:-10000px!important;width:1px!important;height:1px!important;border:0!important;opacity:0!important;pointer-events:none!important;';
    // A known first document lets us distinguish the iframe's initial load from
    // the Apps Script POST response. Polling begins after the response load, so a
    // slow spreadsheet read is not attacked by dozens of concurrent poll calls.
    try{ iframe.srcdoc = '<!doctype html><meta charset="utf-8"><title>SLB secure submit</title>'; }catch(_eSrc){}

    form.method = 'POST';
    form.action = endpoint;
    form.target = frameName;
    form.acceptCharset = 'UTF-8';
    form.enctype = 'application/x-www-form-urlencoded';
    form.style.display = 'none';
    addField_(form, 'payload', outerText);
    addField_(form, 'slbSecureSubmit', '1');
    addField_(form, 'channelHint', channel);

    function submit_(){
      if(phase !== 'boot') return;
      phase = 'submitted';
      try{ form.submit(); }
      catch(err){
        phase = 'failed';
        if(completedResolve) completedResolve({ submitted:false, error:err, at:now() });
      }
    }

    iframe.addEventListener('load', function(){
      if(phase === 'boot'){
        try{ clearTimeout(bootFallback); }catch(_e0){}
        // Submit only after the harmless srcdoc document has loaded.
        setTimeout(submit_, 0);
        return;
      }
      if(phase === 'submitted'){
        phase = 'completed';
        if(completedResolve) completedResolve({ submitted:true, completed:true, at:now() });
      }
    });

    host.appendChild(iframe);
    host.appendChild(form);
    // Some older embedded browsers do not dispatch srcdoc load consistently.
    bootFallback = setTimeout(submit_, 500);

    return {
      completed: completed,
      cleanup: function cleanup(){
        try{ clearTimeout(bootFallback); }catch(_e0){}
        try{ if(form.parentNode) form.parentNode.removeChild(form); }catch(_e1){}
        try{ if(iframe.parentNode) iframe.parentNode.removeChild(iframe); }catch(_e2){}
      }
    };
  }

  function submitByDirectFrame_(endpoint, outerText, timeoutMs, directOpts){
    directOpts = directOpts || {};
    var revealOnBlocked = directOpts.revealOnBlocked !== false;
    var directLabel = String(directOpts.label || 'secure server response');
    var sameOriginReturn = directOpts.sameOriginReceipt === true ? sameOriginDirectReturn_() : '';
    var host = d.body || d.documentElement;
    if(!host) throw new Error('Page is not ready for secure transport.');
    var frameName = 'slb_secure_direct_' + now().toString(36) + '_' + (++seq).toString(36) + '_' + randomHex_(5);
    var token = 'dp_' + randomHex_(18);
    var iframe = d.createElement('iframe');
    var form = d.createElement('form');
    var shell = d.createElement('section');
    var shellBar = d.createElement('div');
    var shellText = d.createElement('strong');
    var shellClose = d.createElement('button');
    var phase = 'boot';
    var done = false;
    var timer = null;
    var bootFallback = 0;
    var revealTimer = 0;

    iframe.name = frameName;
    iframe.title = 'SLB secure direct response';
    iframe.setAttribute('data-slb-secure-transport-frame', 'direct');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.tabIndex = -1;
    iframe.referrerPolicy = 'no-referrer';
    iframe.style.cssText = 'position:fixed!important;left:-10000px!important;top:-10000px!important;width:1px!important;height:1px!important;border:0!important;opacity:0!important;pointer-events:none!important;';
    try{ iframe.srcdoc = '<!doctype html><meta charset="utf-8"><title>SLB secure direct response</title>'; }catch(_eSrc){}
    shell.setAttribute('role', 'dialog');
    shell.setAttribute('aria-label', directLabel);
    shell.style.cssText = 'display:none!important;position:fixed!important;inset:0!important;z-index:2147483646!important;align-items:center!important;justify-content:center!important;flex-direction:column!important;padding:18px!important;background:rgba(2,5,12,.92)!important;box-sizing:border-box!important;';
    shellBar.style.cssText = 'display:flex!important;align-items:center!important;justify-content:space-between!important;gap:16px!important;width:min(640px,100%)!important;padding:11px 14px!important;border:1px solid #dca955!important;border-radius:14px 14px 0 0!important;background:#111a29!important;color:#fff1c4!important;box-sizing:border-box!important;font:700 16px/1.2 Arial,sans-serif!important;';
    shellText.textContent = directLabel;
    shellClose.type = 'button';
    shellClose.textContent = 'Close response';
    shellClose.style.cssText = 'min-height:40px!important;padding:8px 12px!important;border:1px solid #f3c66d!important;border-radius:9px!important;background:#7f321f!important;color:#fff5d6!important;font:800 13px/1.15 Arial,sans-serif!important;cursor:pointer!important;';
    shellBar.appendChild(shellText);
    shellBar.appendChild(shellClose);
    shell.appendChild(shellBar);
    shell.appendChild(iframe);

    form.method = 'POST';
    form.action = endpoint;
    form.target = frameName;
    form.acceptCharset = 'UTF-8';
    form.enctype = 'application/x-www-form-urlencoded';
    form.style.display = 'none';
    addField_(form, 'payload', outerText);
    addField_(form, 'slbDirectPost', '1');
    addField_(form, 'slbDirectPostToken', token);
    if(sameOriginReturn) addField_(form, 'slbDirectReturn', sameOriginReturn);

    function reveal_(){
      if(done) return;
      shell.style.setProperty('display', 'flex', 'important');
      iframe.removeAttribute('aria-hidden');
      iframe.tabIndex = 0;
      iframe.style.cssText = 'display:block!important;position:relative!important;left:auto!important;top:auto!important;width:min(640px,100%)!important;height:min(620px,calc(100vh - 100px))!important;border:1px solid #dca955!important;border-top:0!important;border-radius:0 0 14px 14px!important;background:#07101d!important;opacity:1!important;pointer-events:auto!important;';
    }

    function cleanup_(){
      if(done) return;
      done = true;
      try{ clearTimeout(timer); }catch(_e0){}
      try{ clearTimeout(bootFallback); }catch(_e1){}
      try{ clearTimeout(revealTimer); }catch(_e2){}
      try{ w.removeEventListener('message', onMessage_); }catch(_e2){}
      try{ if(form.parentNode) form.parentNode.removeChild(form); }catch(_e3){}
      try{ if(shell.parentNode) shell.parentNode.removeChild(shell); }catch(_e4){}
    }

    function submit_(){
      if(phase !== 'boot') return;
      phase = 'submitted';
      try{ form.submit(); }
      catch(err){ phase = 'failed'; throw err; }
    }

    function trySameOriginReceipt_(){
      if(!sameOriginReturn) return false;
      try{
        var href=String(iframe.contentWindow&&iframe.contentWindow.location&&iframe.contentWindow.location.href||'');
        if(href.indexOf(sameOriginReturn)!==0) return false;
        var hash=String(iframe.contentWindow.location.hash||'').replace(/^#/,'');
        if(!hash) return false;
        var params=new URLSearchParams(hash);
        if(String(params.get('slbDirectPostToken')||'')!==token) return false;
        var encoded=String(params.get('slbDirectPostMsg')||'');
        if(!encoded) return false;
        var msg=JSON.parse(b64WebSafeToUtf8_(encoded));
        cleanup_();
        directResolve_(msg);
        return true;
      }catch(_e){ return false; }
    }

    function onMessage_(event){
      var origin = String((event && event.origin) || '');
      if(event.source !== iframe.contentWindow && !trustedAppsScriptOrigin_(origin)) return;
      var packet = event && event.data;
      if(!packet || packet.__slbDirectPost !== 1 || packet.token !== token) return;
      var msg = packet.msg;
      cleanup_();
      directResolve_(msg);
    }

    var directResolve_ = null;
    var directReject_ = null;
    var promise = new Promise(function(resolve, reject){ directResolve_ = resolve; directReject_ = reject; });
    shellClose.addEventListener('click', function(){
      cleanup_();
      directReject_(new Error('The secure server response window was closed.'));
    });
    w.addEventListener('message', onMessage_);
    iframe.addEventListener('load', function(){
      if(phase === 'boot'){
        try{ clearTimeout(bootFallback); }catch(_e0){}
        setTimeout(function(){
          try{ submit_(); }
          catch(err){ cleanup_(); directReject_(err); }
        }, 0);
        return;
      }
      if(phase === 'submitted'){
        phase = 'response_loaded';
        // First load is normally the cross-origin Apps Script response. If its
        // postMessage is suppressed, the backend redirects this same iframe to
        // tinyatdragon.com/robots.txt with the token-bound compact envelope in
        // the fragment. That second load is same-origin and readable here.
        if(trySameOriginReceipt_()) return;
        if(revealOnBlocked) revealTimer = setTimeout(reveal_, 900);
        return;
      }
      if(phase === 'response_loaded') trySameOriginReceipt_();
    });
    // Apps Script may fire a transient iframe resource error while it redirects into
    // the googleusercontent HtmlService sandbox. Do not treat that early browser
    // event as proof that the server write failed; the token-bound postMessage or
    // the normal timeout is the authoritative completion signal.
    iframe.onerror = function(){
      try{ iframe.setAttribute('data-slb-frame-error-seen', '1'); }catch(_eFrameErr){}
    };
    host.appendChild(shell);
    host.appendChild(form);
    bootFallback = setTimeout(function(){
      try{ submit_(); }
      catch(err){ cleanup_(); directReject_(err); }
    }, 500);
    timer = setTimeout(function(){
      if(revealOnBlocked){
        reveal_();
        return;
      }
      cleanup_();
      directReject_(new Error('The secure direct response did not return in time.'));
    }, Math.max(8000, Number(timeoutMs || 45000) || 45000));
    return { promise:promise, cleanup:cleanup_ };
  }

  function submitByDirectWindow_(endpoint, outerText, timeoutMs){
    var host = d.body || d.documentElement;
    if(!host) throw new Error('Page is not ready for secure transport.');
    var windowName = 'slb_secure_receipt_' + now().toString(36) + '_' + (++seq).toString(36) + '_' + randomHex_(5);
    var token = 'dp_' + randomHex_(18);
    var popup = w.open('', windowName, 'popup=yes,width=720,height=760,resizable=yes,scrollbars=yes');
    if(!popup) throw new Error('The secure receipt window was blocked. Allow pop-ups for this site and retry.');
    var form = d.createElement('form');
    var done = false;
    var timer = null;
    var closedTimer = null;
    var directResolve_ = null;
    var directReject_ = null;
    form.method = 'POST';
    form.action = endpoint;
    form.target = windowName;
    form.acceptCharset = 'UTF-8';
    form.enctype = 'application/x-www-form-urlencoded';
    form.style.display = 'none';
    addField_(form, 'payload', outerText);
    addField_(form, 'slbDirectPost', '1');
    addField_(form, 'slbDirectPostToken', token);

    function cleanup_(closePopup){
      if(done) return;
      done = true;
      try{ clearTimeout(timer); }catch(_e0){}
      try{ clearInterval(closedTimer); }catch(_e1){}
      try{ w.removeEventListener('message', onMessage_); }catch(_e2){}
      try{ if(form.parentNode) form.parentNode.removeChild(form); }catch(_e3){}
      if(closePopup===true){try{ if(popup&&!popup.closed) popup.close(); }catch(_e4){}}
    }
    function onMessage_(event){
      var origin = String((event && event.origin) || '');
      if(event.source !== popup && !trustedAppsScriptOrigin_(origin)) return;
      var packet = event && event.data;
      if(!packet || packet.__slbDirectPost !== 1 || packet.token !== token) return;
      var msg = packet.msg;
      cleanup_(false);
      directResolve_(msg);
    }
    var promise = new Promise(function(resolve,reject){directResolve_=resolve;directReject_=reject});
    w.addEventListener('message', onMessage_);
    host.appendChild(form);
    try{form.submit()}catch(err){cleanup_(true);directReject_(err);return {promise:promise,cleanup:cleanup_}}
    closedTimer = setInterval(function(){
      try{
        if(popup.closed){
          cleanup_(false);
          directReject_(new Error('The secure receipt window was closed before SLB returned the case code. The local draft remains safe.'));
        }
      }catch(_eClosed){}
    },500);
    timer = setTimeout(function(){
      cleanup_(false);
      directReject_(new Error('The secure receipt window did not return the case code in time. If it shows a TC code, record it before closing; the local draft remains safe.'));
    },Math.max(30000,Number(timeoutMs||120000)||120000));
    return {promise:promise,cleanup:cleanup_};
  }

  function submitByFetch_(endpoint, outerText){
    if(typeof w.fetch !== 'function') return Promise.reject(new Error('Fetch unavailable.'));
    return w.fetch(endpoint, {
      method: 'POST',
      mode: 'no-cors',
      credentials: 'omit',
      cache: 'no-store',
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: outerText
    });
  }

  function jsonpData_(endpoint, payload, timeoutMs){
    return new Promise(function(resolve, reject){
      var rid = String(payload && payload.requestId || ('spoll_' + now().toString(36) + '_' + (++seq).toString(36) + '_' + randomHex_(5)));
      payload.requestId = rid;
      var script = d.createElement('script');
      // This JSONP poll is an SLB-owned secure-transport resource. Privacy tools
      // or Apps Script redirects may make the script element emit a capture-phase
      // resource error before jsonpData_ rejects and pollAction_ falls back to the
      // framed postMessage channel. Mark it so the global SLB error guard does not
      // misreport that recoverable transport event as a whole-page failure.
      script.setAttribute('data-slb-rpc-script', '1');
      script.setAttribute('data-slb-secure-transport-script', 'poll');
      var done = false;
      var timer = null;
      w.__TYW_CB = w.__TYW_CB || {};

      function cleanup_(){
        if(done) return;
        done = true;
        try{ clearTimeout(timer); }catch(_e0){}
        try{ delete w.__TYW_CB[rid]; }catch(_e1){}
        try{ if(script.parentNode) script.parentNode.removeChild(script); }catch(_e2){}
      }

      w.__TYW_CB[rid] = function(msg){
        cleanup_();
        if(msg && msg.ok){ resolve(msg.data != null ? msg.data : {}); return; }
        reject(normalizeError_(msg, 'Secure response poll failed.'));
      };
      script.onerror = function(){ cleanup_(); reject(new Error('Secure response poll was blocked.')); };
      timer = setTimeout(function(){ cleanup_(); reject(new Error('Secure response poll timed out.')); }, Math.max(5000, Number(timeoutMs || 12000) || 12000));
      var sep = endpoint.indexOf('?') >= 0 ? '&' : '?';
      script.async = true;
      script.referrerPolicy = 'no-referrer';
      script.src = endpoint + sep + 'payload=' + encodeURIComponent(JSON.stringify(payload)) + '&_=' + now();
      (d.head || d.documentElement).appendChild(script);
    });
  }

  function frameData_(endpoint, payload, timeoutMs){
    return new Promise(function(resolve, reject){
      var token = 'fp_' + randomHex_(18);
      var iframe = d.createElement('iframe');
      var done = false;
      var timer = null;

      function cleanup_(){
        if(done) return;
        done = true;
        try{ clearTimeout(timer); }catch(_e0){}
        try{ w.removeEventListener('message', onMessage_); }catch(_e1){}
        try{ if(iframe.parentNode) iframe.parentNode.removeChild(iframe); }catch(_e2){}
      }

      function onMessage_(event){
        var origin = String((event && event.origin) || '');
        // Apps Script HtmlService runs user HTML in a nested
        // *.googleusercontent.com sandbox, so its WindowProxy is not the outer
        // iframe. Bind nested responses to Google's origin plus the random
        // per-frame token; direct non-nested responses remain source-bound.
        if(event.source !== iframe.contentWindow && !trustedAppsScriptOrigin_(origin)) return;
        var packet = event && event.data;
        if(!packet || packet.__slbFramePoll !== 1 || packet.token !== token) return;
        cleanup_();
        var msg = packet.msg;
        if(msg && msg.ok){ resolve(msg.data != null ? msg.data : {}); return; }
        reject(normalizeError_(msg, 'Secure response frame failed.'));
      }

      w.addEventListener('message', onMessage_);
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('title', 'Secure response channel');
      iframe.setAttribute('data-slb-secure-transport-frame', 'poll');
      iframe.setAttribute('tabindex', '-1');
      iframe.referrerPolicy = 'no-referrer';
      iframe.style.cssText = 'position:fixed!important;width:1px!important;height:1px!important;left:-10000px!important;top:-10000px!important;border:0!important;opacity:0!important;pointer-events:none!important';
      // A redirect-stage iframe error can be reported before Apps Script finishes
      // loading the HtmlService response. Keep listening for the authenticated
      // token-bound postMessage and let the timeout decide if the channel truly died.
      iframe.onerror = function(){ try{ iframe.setAttribute('data-slb-frame-error-seen','1'); }catch(_eFrameErr){} };
      timer = setTimeout(function(){ cleanup_(); reject(new Error('Secure response frame timed out.')); }, Math.max(5000, Number(timeoutMs || 12000) || 12000));
      var sep = endpoint.indexOf('?') >= 0 ? '&' : '?';
      iframe.src = endpoint + sep + 'slbFramePoll=1&slbFrameToken=' + encodeURIComponent(token) + '&payload=' + encodeURIComponent(JSON.stringify(payload)) + '&_=' + now();
      (d.body || d.documentElement).appendChild(iframe);
    });
  }

  function pollAction_(endpoint, action, channel, extra, timeoutMs){
    var args = { channel: channel };
    if(extra){
      Object.keys(extra).forEach(function(k){ args[k] = extra[k]; });
    }
    var payload = {
      requestId: 'spoll_' + now().toString(36) + '_' + (++seq).toString(36) + '_' + randomHex_(5),
      action: action,
      args: args
    };
    // Keep the lightweight script poll as the normal path. If a privacy tool
    // blocks that script request, retry the same credential-free opaque poll in
    // a framed postMessage channel. Sequential fallback avoids doubling every
    // Apps Script poll under ordinary traffic.
    return jsonpData_(endpoint, payload, timeoutMs).catch(function(jsonpError){
      return frameData_(endpoint, payload, timeoutMs).catch(function(frameError){
        throw frameError || jsonpError;
      });
    });
  }

  function b64WebSafeToUtf8_(b64){
    var s = String(b64 || '').replace(/-/g, '+').replace(/_/g, '/');
    while(s.length % 4) s += '=';
    var bin = w.atob(s);
    var bytes = new Uint8Array(bin.length);
    for(var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    try{
      if(typeof TextDecoder !== 'undefined') return new TextDecoder('utf-8', { fatal:false }).decode(bytes);
    }catch(_e1){}
    var escaped = '';
    for(var j = 0; j < bytes.length; j++) escaped += '%' + ('0' + bytes[j].toString(16)).slice(-2);
    try{ return decodeURIComponent(escaped); }catch(_e2){ return bin; }
  }

  function retryablePollError_(err){
    var text = String((err && err.message) || err || '').toLowerCase();
    return /timed out|blocked|network|failed to load|load error|temporarily unavailable/.test(text);
  }

  async function fetchPart_(endpoint, channel, index, deadline){
    var attempts = 0;
    while(now() < deadline){
      attempts++;
      var data = null;
      try{
        data = await pollAction_(endpoint, '__securePollV1', channel, { index:index }, 20000);
      }catch(err){
        // A long Apps Script read can temporarily serialize the tiny poll behind
        // the original POST. One timed-out poll must not kill the whole request.
        if(retryablePollError_(err) && now() < deadline){
          await wait_(Math.min(2200, 700 + attempts * 160));
          continue;
        }
        throw err;
      }
      if(data && data.state === 'part' && Number(data.index) === index) return String(data.part || '');
      if(data && (data.state === 'part_wait' || data.state === 'pending' || data.state === 'waiting')){
        await wait_(Math.min(1800, 650 + attempts * 140));
        continue;
      }
      throw new Error('Secure response part ' + index + ' is unavailable.');
    }
    throw new Error('Secure response part timed out.');
  }

  async function collectEnvelope_(endpoint, channel, rid, deadline, onNoMeta){
    var attempts = 0;
    var meta = null;
    while(now() < deadline){
      attempts++;
      var data = null;
      try{
        data = await pollAction_(endpoint, '__securePollV1', channel, null, 20000);
      }catch(err){
        if(retryablePollError_(err) && now() < deadline){
          if(typeof onNoMeta === 'function') onNoMeta(attempts);
          await wait_(Math.min(2200, 700 + attempts * 160));
          continue;
        }
        throw err;
      }
      if(data && data.state === 'ready'){
        meta = data;
        break;
      }
      if(data && data.state === 'waiting' && typeof onNoMeta === 'function') onNoMeta(attempts);
      await wait_(Math.min(1800, 650 + attempts * 140));
    }
    if(!meta) throw new Error('Secure backend timeout. The request was not completed.');
    if(String(meta.requestId || '') !== rid) throw new Error('Secure response request ID mismatch.');

    var count = Number(meta.parts || 0);
    if(!isFinite(count) || count < 1 || count > 72) throw new Error('Secure response metadata is invalid.');
    var pieces = new Array(count);
    var cursor = 0;
    var workers = [];
    var workerCount = Math.min(4, count);
    for(var widx = 0; widx < workerCount; widx++){
      workers.push((async function(){
        while(true){
          var idx = cursor++;
          if(idx >= count) return;
          pieces[idx] = await fetchPart_(endpoint, channel, idx, deadline);
        }
      })());
    }
    await Promise.all(workers);
    var encoded = pieces.join('');
    if(Number(meta.encodedChars || encoded.length) !== encoded.length) throw new Error('Secure response length mismatch.');
    var text = b64WebSafeToUtf8_(encoded);
    var envelope;
    try{ envelope = JSON.parse(text); }catch(_eJson){ throw new Error('Secure response could not be decoded.'); }
    if(!envelope || envelope.__tyw !== 1) throw new Error('Secure response envelope is invalid.');
    if(String(envelope.requestId || '') !== rid) throw new Error('Secure response envelope mismatch.');
    return envelope;
  }

  function forceSecureAction_(action){
    var a = String(action || '').trim();
    // Diary bodies are too important and often too large for the old JSONP URL
    // transport. Some Safari privacy tools also block cross-site script polls.
    // Keep every diary save/read/verification on POST-based transport even when
    // the browser is otherwise using old-Mac compatibility mode.
    return /^(diary[A-Za-z0-9_]*|adminUaePublishGameLayout|adminAofPublicProfilePublish|aofPublicProfileGet|adminFocusGet|adminFocusSave|adminFocusAllGet|adminFocusAllSave)$/.test(a);
  }

  function preferFetchSubmission_(action){
    var a = String(action || '').trim();
    // Read-heavy standalone pages work better when the no-CORS POST begins
    // immediately. The promise normally settles after Apps Script has finished,
    // avoiding premature poll traffic during cold spreadsheet reads.
      return /^(thunderCourtSubmit|chatRoomsList|chatRoomList|chatRooms|chatRoomsListV2|chatListRooms|chatFetch|offeringGetState|uaeGameLayoutGet|aofPublicProfileGet|getLibraryAccess|libraryLogin|tydLibrary|adminLibraryTelemetry|diary[A-Za-z0-9_]*)$/.test(a);
  }

  function actionTimeoutFloor_(action){
    var a = String(action || '').trim();
    // Library directory/text reads can legitimately take longer on the first
    // cold Apps Script execution. Keep one overall deadline while individual
    // credential-free polls retry safely inside it.
    if(/^tydLibrary/i.test(a) || a === 'adminLibraryTelemetry') return 180000;
    if(a === 'loginBundle') return 90000;
    if(a === 'login') return 60000;
    if(a === 'getLibraryAccess' || a === 'libraryLogin') return 90000;
    if(/^chat/i.test(a)) return 90000;
    if(/^(diaryDeskListPending|diaryInboxStats|diaryList|diaryListFlagged|diarySearch|diaryExportCsv|diaryExportZip)$/.test(a)) return 150000;
    if(/^diary/.test(a)) return 180000;
    if(a === 'uaeGameLayoutGet') return 60000;
    if(a === 'aofPublicProfileGet') return 90000;
    if(a === 'adminFocusGet' || a === 'adminFocusSave') return 60000;
    if(a === 'adminFocusAllGet' || a === 'adminFocusAllSave') return 120000;
    if(a === 'adminUaePublishGameLayout' || a === 'adminAofPublicProfilePublish') return 120000;
    if(/^(offering|adminOffering)/i.test(a)) return 90000;
    return 0;
  }

  function transportFailure_(err){
    var text = String((err && err.message) || err || '').toLowerCase();
    return /secure backend timeout|secure response poll|too many secure requests|transport failed|failed to load|load error|blocked|network|timed out/.test(text);
  }

  function fallbackSafeAction_(action){
    var a = String(action || '');
    return /^(login|loginBundle|health|ping|get|list|fetch|boardList|boardGet|boardRead|chatRooms|chatRoomList|chatListRooms|chatFetch|offeringGetState|uaeGameLayoutGet|libraryLogin|getLibraryAccess|m3ReceivedList|diaryGet|diaryList|diaryDiscipleAppSync|diaryDiscipleAppVerifySubmit)/i.test(a);
  }

  function legacyPayload_(payload){
    var out = {};
    Object.keys(payload || {}).forEach(function(k){ out[k] = payload[k]; });
    out.transport = LEGACY_VERSION;
    if(!out.requestId) out.requestId = requestId_(out);
    if(!out.clientBuild) out.clientBuild = clientBuild_();
    return out;
  }

  function legacyCall_(endpoint, payload, opts){
    opts = opts || {};
    var url = safeEndpoint_(endpoint);
    var p = legacyPayload_(payload || {});
    var raw = '';
    try{ raw = JSON.stringify(p); }catch(_eJson){ return Promise.reject(new Error('Request could not be encoded.')); }
    if(raw.length > LEGACY_MAX_CHARS){
      return Promise.reject(new Error('This request is too large for old-browser compatibility mode. Please use a newer browser for this action.'));
    }
    var timeoutMs = Math.max(8000, Math.min(180000, Math.max(Number(opts.timeoutMs || 45000) || 45000, actionTimeoutFloor_(p.action))));
    var started = now();
    diagPush_(p.action, p.requestId, 'legacy_start', 0, oldSafariCompat_() ? 'OLD_SAFARI' : 'FALLBACK');
    return jsonpData_(url, p, timeoutMs).then(function(data){
      try{ w.__SLB_TRANSPORT_STATUS__ = { mode:LEGACY_VERSION, ok:true, requestId:p.requestId, action:String(p.action || ''), at:now() }; }catch(_eStatus){}
      diagPush_(p.action, p.requestId, 'legacy_complete', Math.max(0, now()-started), 'OK');
      return data;
    }).catch(function(err){
      diagPush_(p.action, p.requestId, 'legacy_failed', Math.max(0, now()-started), String((err && err.code) || 'ERR'));
      throw err;
    });
  }

  function callEnvelope(endpoint, payload, opts){
    opts = opts || {};
    payload = payload && typeof payload === 'object' ? payload : {};
    return new Promise(function(resolve, reject){
      var url;
      try{ url = safeEndpoint_(endpoint); }catch(e){ reject(e); return; }
      try{
        if(Object.keys(active).length >= MAX_ACTIVE){ reject(new Error('Too many secure requests are running. Please wait.')); return; }
      }catch(_eCap){}

      var rid = requestId_(payload);
      payload.requestId = rid;
      payload.transport = VERSION;
      if(!payload.clientBuild) payload.clientBuild = clientBuild_();
      var payloadText;
      try{ payloadText = JSON.stringify(payload); }catch(_ePayload){ reject(new Error('Request could not be encoded.')); return; }
      var maxChars = Math.max(32768, Number(opts.maxChars || 1700000) || 1700000);
      if(payloadText.length > maxChars){ reject(new Error('Request is too large for secure transport.')); return; }

      var channel = 'sp1_' + randomHex_(24);
      var outer = {
        requestId: 'submit_' + rid,
        action: '__secureSubmitV1',
        args: { transport:VERSION, channel:channel, payload:payloadText }
      };
      var outerText = JSON.stringify(outer);
      var timeoutMs = Math.max(8000, Math.min(180000, Math.max(Number(opts.timeoutMs || 35000) || 35000, actionTimeoutFloor_(payload.action))));
      var deadline = now() + timeoutMs;
      var formCleanup = null;
      var formCompleted = null;
      var fetchFallbackStarted = false;
      var formFallbackStarted = false;
      var fetchFirst = preferFetchSubmission_(payload.action) && typeof w.fetch === 'function';
      active[rid] = { channel:channel, action:String(payload.action || ''), startedAt:now() };
      publishActivity_();
      var actionName = String(payload.action || '');
      var diaryDirect = /^diary[A-Za-z0-9_]*$/.test(actionName);
      var uaeWriteDirect = /^(adminUaePublishGameLayout|adminAofPublicProfilePublish)$/.test(actionName);
      var focusReadDirect = actionName === 'adminFocusGet' || actionName === 'adminFocusAllGet';
      var focusWriteDirect = actionName === 'adminFocusSave' || actionName === 'adminFocusAllSave';
      var focusDirect = focusReadDirect || focusWriteDirect;
      var compactWriteDirect = uaeWriteDirect || focusDirect;
      var loginDirect = /^(login|loginBundle)$/.test(actionName);
      var directFrame = /^(login|loginBundle|thunderCourtSubmit|adminUaePublishGameLayout|adminAofPublicProfilePublish|adminFocusGet|adminFocusSave|adminFocusAllGet|adminFocusAllSave|uaeGameLayoutGet|aofPublicProfileGet)$/.test(actionName) || diaryDirect;
      var visibleDirect = actionName === 'thunderCourtSubmit' && opts.visibleResponse === true;
      var quietDirectRead = /^(uaeGameLayoutGet|aofPublicProfileGet)$/.test(actionName);
      diagPush_(payload.action, rid, 'submit_start', 0, visibleDirect ? 'DIRECT_WINDOW' : (directFrame ? 'DIRECT_FRAME' : (fetchFirst ? 'FETCH' : 'FORM')));

      function finish_(fn, value){
        try{ delete active[rid]; }catch(_e0){}
        publishActivity_();
        try{ if(formCleanup) formCleanup(); }catch(_e1){}
        fn(value);
      }

      function startFormFallback_(){
        if(formFallbackStarted) return formCompleted || Promise.resolve(null);
        formFallbackStarted = true;
        try{
          var formState = submitByForm_(url, outerText, channel);
          formCleanup = formState && formState.cleanup;
          formCompleted = formState && formState.completed;
          diagPush_(payload.action, rid, 'form_fallback', Math.max(0, now() - active[rid].startedAt), 'FORM');
          return formCompleted || Promise.resolve(null);
        }catch(_formErr){
          diagPush_(payload.action, rid, 'form_fallback_failed', Math.max(0, now() - active[rid].startedAt), 'FORM');
          return Promise.resolve(null);
        }
      }

      if(directFrame){
        try{
          var directState = visibleDirect
            ? submitByDirectWindow_(url, outerText, timeoutMs)
            : submitByDirectFrame_(url, outerText, timeoutMs, {
                revealOnBlocked: !(diaryDirect || compactWriteDirect || loginDirect || quietDirectRead),
                sameOriginReceipt: !!(compactWriteDirect || (quietDirectRead && payload.args && payload.args.foodOnly === true)),
                label: loginDirect ? 'SLB secure login response' : (diaryDirect ? 'SLB diary response' : (focusReadDirect ? (actionName === 'adminFocusAllGet' ? 'FOCUS ALL load response' : 'FOCUS load response') : (focusWriteDirect ? (actionName === 'adminFocusAllSave' ? 'FOCUS ALL save response' : 'FOCUS save response') : (uaeWriteDirect ? 'UAE backend save response' : (quietDirectRead ? 'Offering Hall public release response' : 'Authoritative SLB server response')))))
              });
          formCleanup = directState && directState.cleanup;
          diagPush_(payload.action, rid, visibleDirect ? 'direct_window_start' : 'direct_frame_start', 0, 'POST');
          if(loginDirect){
            var loginSettled = false;
            var loginFailures = [];
            function finishLogin_(msg){
              if(loginSettled) return;
              loginSettled = true;
              try{ w.__SLB_TRANSPORT_STATUS__ = { mode:VERSION, ok:!!(msg && msg.ok), requestId:rid, action:String(payload.action || ''), at:now() }; }catch(_eLoginStatus){}
              diagPush_(payload.action, rid, 'complete', Math.max(0, now() - active[rid].startedAt), msg && msg.ok ? 'OK' : String((msg && (msg.errorCode || (msg.error && msg.error.code))) || 'ERR'));
              finish_(resolve, msg);
            }
            function failLogin_(error){
              if(loginSettled) return;
              loginFailures.push(error);
              if(loginFailures.length < 2) return;
              loginSettled = true;
              diagPush_(payload.action, rid, 'login_direct_failed', Math.max(0, now() - active[rid].startedAt), 'BOTH');
              finish_(reject, loginFailures[1] || loginFailures[0] || new Error('Secure login response did not return.'));
            }
            // The direct hidden POST response and the credential-free opaque poll
            // race each other. A blocked poll can no longer lock the user out when
            // the secure POST has already completed successfully.
            directState.promise.then(finishLogin_, failLogin_);
            collectEnvelope_(url, channel, rid, deadline).then(finishLogin_, failLogin_);
            return;
          }
          if(focusDirect){
            var focusSettled = false;
            function finishFocus_(msg){
              if(focusSettled) return;
              focusSettled = true;
              try{ w.__SLB_TRANSPORT_STATUS__ = { mode:VERSION, ok:!!(msg && msg.ok), requestId:rid, action:String(payload.action || ''), at:now() }; }catch(_eFocusStatus){}
              diagPush_(payload.action, rid, 'complete', Math.max(0, now() - active[rid].startedAt), msg && msg.ok ? 'OK' : String((msg && (msg.errorCode || (msg.error && msg.error.code))) || 'ERR'));
              finish_(resolve, msg);
            }
            function failFocus_(error){
              if(focusSettled) return;
              focusSettled = true;
              diagPush_(payload.action, rid, 'focus_direct_failed', Math.max(0, now() - active[rid].startedAt), 'DIRECT');
              finish_(reject, error || new Error(focusReadDirect ? 'The FOCUS direct load response did not return.' : 'The FOCUS direct save response did not return.'));
            }
            // FOCUS admin reads and writes are compact and the user's browser may block
            // the opaque JSONP poll transport entirely. Do NOT open the poll channel
            // for either action. The authoritative completion signal is the hidden
            // POST's token-bound postMessage or its first-party /robots.txt receipt.
            directState.promise.then(finishFocus_, failFocus_);
            return;
          }
          if(uaeWriteDirect){
            var uaeSettled = false;
            var uaeFailures = [];
            function finishUae_(msg){
              if(uaeSettled) return;
              uaeSettled = true;
              try{ w.__SLB_TRANSPORT_STATUS__ = { mode:VERSION, ok:!!(msg && msg.ok), requestId:rid, action:String(payload.action || ''), at:now() }; }catch(_eUaeStatus){}
              diagPush_(payload.action, rid, 'complete', Math.max(0, now() - active[rid].startedAt), msg && msg.ok ? 'OK' : String((msg && (msg.errorCode || (msg.error && msg.error.code))) || 'ERR'));
              finish_(resolve, msg);
            }
            function failUae_(error){
              if(uaeSettled) return;
              uaeFailures.push(error);
              if(uaeFailures.length < 2) return;
              uaeSettled = true;
              diagPush_(payload.action, rid, 'uae_direct_failed', Math.max(0, now() - active[rid].startedAt), 'BOTH');
              finish_(reject, uaeFailures[1] || uaeFailures[0] || new Error('The UAE backend save response did not return.'));
            }
            // UAE writes stay fully hidden. The direct POST gets a short head start;
            // if browser privacy blocks the iframe message, the compact receipt is
            // collected with the same request ID instead of showing a confusing popup.
            directState.promise.then(finishUae_, failUae_);
            wait_(12000).then(function(){
              if(uaeSettled) return null;
              return collectEnvelope_(url, channel, rid, deadline);
            }).then(function(msg){ if(msg) finishUae_(msg); }, failUae_);
            return;
          }
          if(diaryDirect){
            var diarySettled = false;
            var diaryFailures = [];
            function finishDiary_(msg){
              if(diarySettled) return;
              diarySettled = true;
              try{ w.__SLB_TRANSPORT_STATUS__ = { mode:VERSION, ok:!!(msg && msg.ok), requestId:rid, action:String(payload.action || ''), at:now() }; }catch(_eDiaryStatus){}
              diagPush_(payload.action, rid, 'complete', Math.max(0, now() - active[rid].startedAt), msg && msg.ok ? 'OK' : String((msg && (msg.errorCode || (msg.error && msg.error.code))) || 'ERR'));
              finish_(resolve, msg);
            }
            function failDiary_(error){
              if(diarySettled) return;
              diaryFailures.push(error);
              if(diaryFailures.length < 2) return;
              diarySettled = true;
              diagPush_(payload.action, rid, 'diary_direct_failed', Math.max(0, now() - active[rid].startedAt), 'BOTH');
              finish_(reject, diaryFailures[1] || diaryFailures[0] || new Error('Secure diary response did not return.'));
            }
            // Every Diary read, reply and submission uses the direct POST response first.
            // Give that primary path a short head start before opening the opaque
            // receipt fallback. This avoids unnecessary poll traffic during normal
            // Diary use while retaining recovery if an embedded response is blocked.
            directState.promise.then(finishDiary_, failDiary_);
            wait_(8000).then(function(){
              if(diarySettled) return null;
              return collectEnvelope_(url, channel, rid, deadline);
            }).then(function(msg){
              if(msg) finishDiary_(msg);
            }, failDiary_);
            return;
          }
          if(visibleDirect){
            var visibleSettled = false;
            var visibleFailures = [];
            function finishVisible_(msg){
              if(visibleSettled) return;
              visibleSettled = true;
              try{
                w.__SLB_TRANSPORT_STATUS__ = {
                  mode: VERSION,
                  ok: !!(msg && msg.ok),
                  requestId: rid,
                  action: String(payload.action || ''),
                  at: now()
                };
              }catch(_eVisibleStatus){}
              diagPush_(payload.action, rid, 'complete', Math.max(0, now() - active[rid].startedAt), msg && msg.ok ? 'OK' : String((msg && (msg.errorCode || (msg.error && msg.error.code))) || 'ERR'));
              finish_(resolve, msg);
            }
            function failVisible_(error){
              if(visibleSettled) return;
              visibleFailures.push(error);
              if(visibleFailures.length < 2) return;
              visibleSettled = true;
              diagPush_(payload.action, rid, 'direct_window_failed', Math.max(0, now() - active[rid].startedAt), 'RECEIPT_OPEN');
              finish_(reject, visibleFailures[1] || visibleFailures[0] || new Error('The secure server receipt did not return.'));
            }
            directState.promise.then(finishVisible_,failVisible_);
            collectEnvelope_(url, channel, rid, deadline).then(finishVisible_,failVisible_);
            return;
          }
          directState.promise.then(function(msg){
            try{
              w.__SLB_TRANSPORT_STATUS__ = {
                mode: VERSION,
                ok: !!(msg && msg.ok),
                requestId: rid,
                action: String(payload.action || ''),
                at: now()
              };
            }catch(_eStatus){}
            diagPush_(payload.action, rid, 'complete', Math.max(0, now() - active[rid].startedAt), msg && msg.ok ? 'OK' : String((msg && (msg.errorCode || (msg.error && msg.error.code))) || 'ERR'));
            finish_(resolve, msg);
          }).catch(function(directError){
            diagPush_(payload.action, rid, 'direct_frame_failed', Math.max(0, now() - active[rid].startedAt), 'FALLBACK');
            // The direct POST may have completed even when a privacy tool
            // blocked its message. Reuse the same channel and idempotency key;
            // a fetch retry cannot execute the write twice.
            submitByFetch_(url, outerText).catch(function(){});
            collectEnvelope_(url, channel, rid, deadline).then(function(msg){
              diagPush_(payload.action, rid, 'complete', Math.max(0, now() - active[rid].startedAt), msg && msg.ok ? 'OK' : 'ERR');
              finish_(resolve, msg);
            }).catch(function(pollError){
              finish_(reject, pollError || directError);
            });
          });
          return;
        }catch(directSetupError){
          diagPush_(payload.action, rid, visibleDirect ? 'direct_window_failed' : 'direct_frame_failed', 0, 'SETUP:'+String(directSetupError&&directSetupError.message||directSetupError).slice(0,80));
          // A pop-up can lose user activation while the authenticated RPC wrapper
          // prepares the request. Fall back immediately to the hidden direct POST
          // frame instead of forcing Thunder Court onto a blocker-sensitive poll.
          if(visibleDirect){
            try{
              var hiddenState = submitByDirectFrame_(url, outerText, timeoutMs, { revealOnBlocked:true, label:'Authoritative SLB server response' });
              formCleanup = hiddenState && hiddenState.cleanup;
              diagPush_(payload.action, rid, 'direct_frame_fallback_start', 0, 'POST');
              hiddenState.promise.then(function(msg){
                try{w.__SLB_TRANSPORT_STATUS__={mode:VERSION,ok:!!(msg&&msg.ok),requestId:rid,action:String(payload.action||''),at:now()}}catch(_eFallbackStatus){}
                diagPush_(payload.action, rid, 'complete', Math.max(0, now()-active[rid].startedAt), msg&&msg.ok?'OK':String((msg&&(msg.errorCode||(msg.error&&msg.error.code)))||'ERR'));
                finish_(resolve,msg);
              }).catch(function(hiddenError){
                diagPush_(payload.action, rid, 'direct_frame_fallback_failed', Math.max(0, now()-active[rid].startedAt), 'POLL');
                submitByFetch_(url,outerText).catch(function(){});
                collectEnvelope_(url,channel,rid,deadline).then(function(msg){finish_(resolve,msg)}).catch(function(pollError){finish_(reject,pollError||hiddenError||directSetupError)});
              });
              return;
            }catch(hiddenSetupError){
              diagPush_(payload.action, rid, 'direct_frame_fallback_failed', 0, 'SETUP:'+String(hiddenSetupError&&hiddenSetupError.message||hiddenSetupError).slice(0,80));
            }
          }
        }
      }

      if(fetchFirst){
        fetchFallbackStarted = true;
        // Fast read path: start the POST immediately. If a browser blocks the
        // no-CORS request, fall back to the hidden form without changing channel.
        formCompleted = submitByFetch_(url, outerText).catch(function(){
          return startFormFallback_();
        });
      }else{
        try{
          var formState = submitByForm_(url, outerText, channel);
          formFallbackStarted = true;
          formCleanup = formState && formState.cleanup;
          formCompleted = formState && formState.completed;
        }catch(formErr){
          fetchFallbackStarted = true;
          formCompleted = submitByFetch_(url, outerText).catch(function(){ return null; });
        }
      }

      // Poll after the primary POST finishes. The watchdog is only a safety net
      // for browsers that never settle an opaque fetch or iframe load event.
      var pollGate = Promise.race([
        formCompleted || Promise.resolve(null),
        wait_(fetchFirst ? 30000 : 5000).then(function(){ return { watchdog:true }; })
      ]);

      pollGate.then(function(){
        diagPush_(payload.action, rid, 'poll_start', Math.max(0, now() - active[rid].startedAt), '');
        return collectEnvelope_(url, channel, rid, deadline, function(attempts){
          // If neither the form completion nor the first few polls produced a
          // channel record, retry the same channel once by no-CORS fetch. The
          // backend channel lock prevents duplicate execution.
          if(fetchFirst){
            if(!formFallbackStarted && attempts >= 4) startFormFallback_();
          }else if(!fetchFallbackStarted && attempts >= 4){
            fetchFallbackStarted = true;
            submitByFetch_(url, outerText).catch(function(){});
          }
        });
      }).then(function(msg){
        try{
          w.__SLB_TRANSPORT_STATUS__ = {
            mode: VERSION,
            ok: !!msg.ok,
            requestId: rid,
            action: String(payload.action || ''),
            at: now()
          };
        }catch(_eStatus){}
        diagPush_(payload.action, rid, 'complete', Math.max(0, now() - active[rid].startedAt), msg && msg.ok ? 'OK' : String((msg && (msg.errorCode || (msg.error && msg.error.code))) || 'ERR'));
        pollAction_(url, '__secureAckV1', channel, null, 8000).catch(function(){});
        finish_(resolve, msg);
      }).catch(function(err){
        var finalErr = err instanceof Error ? err : new Error(String(err || 'Secure transport failed.'));
        diagPush_(payload.action, rid, 'failed', active[rid] ? Math.max(0, now() - active[rid].startedAt) : 0, String(finalErr.code || 'TRANSPORT'));
        finish_(reject, finalErr);
      });
    });
  }

  function call(endpoint, payload, opts){
    opts = opts || {};
    payload = payload && typeof payload === 'object' ? payload : {};

    // Old Safari/WebKit normally receives the simpler one-shot transport.
    // Diary traffic is the exception: rich diary bodies must never be placed in
    // a JSONP URL, and Safari content blockers commonly reject that script poll.
    if(shouldUseCompat_() && !forceSecureAction_(payload.action)) return legacyCall_(endpoint, payload, opts);

    return callEnvelope(endpoint, payload, opts).then(function(msg){
      if(msg && msg.ok) return msg.data != null ? msg.data : {};
      throw normalizeError_(msg, 'Backend error');
    }).catch(function(err){
      // A read/login request is safe to retry once through compatibility mode.
      // Writes are never retried after an uncertain secure submission, avoiding
      // accidental duplicate transfers or posts.
      if(transportFailure_(err) && fallbackSafeAction_(payload.action) && !forceSecureAction_(payload.action)){
        enableCompat_('SECURE_FAILURE');
        return legacyCall_(endpoint, payload, opts);
      }
      throw err;
    });
  }

  function diagnostics(){
    var rows = [];
    try{
      Object.keys(active).forEach(function(k){
        var x = active[k] || {};
        rows.push({ requestId:k, action:x.action || '', ageMs:Math.max(0, now() - Number(x.startedAt || now())) });
      });
    }catch(_e){}
    return { version:VERSION, compatibility:shouldUseCompat_() ? LEGACY_VERSION : '', safariMajor:safariMajor_(), build:clientBuild_(), active:rows, recent:diagEvents.slice(-DIAG_MAX) };
  }

  w.SLBPostBridge = {
    version: VERSION,
    tabId: TAB_ID,
    call: call,
    callEnvelope: callEnvelope,
    diagnostics: diagnostics,
    activity: activity_,
    enableCompatibility: function(){ enableCompat_('MANUAL'); },
    disableCompatibility: function(){ try{ if(w.sessionStorage) w.sessionStorage.removeItem(COMPAT_KEY); if(w.localStorage) w.localStorage.removeItem(COMPAT_KEY); }catch(_e){} },
    compatibility: function(){ return { enabled:shouldUseCompat_(), safariMajor:safariMajor_(), mode:shouldUseCompat_() ? LEGACY_VERSION : VERSION }; }
  };
})(window, document);

